import React from 'react';
import { connect } from 'react-redux';
import MultiCurrency from './multi-currency';

const MultiCurrencyContainer = props => {
    const { amountInSek, preferredCurrency } = props;
    return (
        <MultiCurrency
            amountInSek={amountInSek}
            preferredCurrency={preferredCurrency}
        />
    );
};

const mapStateToProps = state => {
    return {
        preferredCurrency: state.multiCurrency.preferredCurrency
    };
};

export default connect(mapStateToProps)(MultiCurrencyContainer);
